<template>
  <div class="outer">
    <div class="indexPanel1 flex">
      <ClassNav />
      <TopPicNews />
    </div>
    <div class="indexNews">
      <News />
    </div>
  </div>
</template>

<script>
import ClassNav from "./ClassNav";
import TopPicNews from "./TopPicNews";
import News from "./News";
export default {
  components: {
    ClassNav,
    TopPicNews,
    News
  },
};
</script>

<style scoped>
.outer {
  width: 100%;
  background-color: #f9f9f9;
  padding-top: 64px;
  padding-bottom: 38px;
}
.indexPanel1 {
  width: 1200px;
  height: 440px;
  margin: 0 auto;
  margin-bottom: 24px;
}
.indexNews {
  margin: 0 auto;
}
</style>